
import { useEffect, useRef, useState } from "react"
import { Box, Flex, Text } from "rebass/styled-components"
import styled, { keyframes } from "styled-components"
import { Menu as MenuInner, MenuItem, FocusableItem, MenuDivider } from '@szhsin/react-menu';
import {
  menuSelector,
  menuItemSelector,
  menuDividerSelector
} from "@szhsin/react-menu/style-utils";
import '@szhsin/react-menu/dist/core.css';
import { InputNoForm } from "../../../components/TextInput";
import { ApolloCache, DefaultContext, FetchResult, MutationFunctionOptions, useMutation, useQuery } from "@apollo/client";
import { GET_CONVERSATION_BY_ID, GET_HELPSCOUT_USERS } from "../../../graphql/queries";
import { IGetHelpscoutUsersOutput, IHelpscoutUser, IIGetHelpscoutUsersInput } from "../../../graphql/types/queries/conversation";
import { IUser } from "../../../graphql/types/queries/user";
import { useMe } from "../../../hooks/useMe";
import { toast } from "react-toastify";
import { IProviderReassignConversationOutput, IProviderReassignConversationInput, IProviderChangeStatusConversationOutput, IProviderChangeStatusConversationInput, ISnoozeConversationOutput, ISnoozeConversationInput } from "../../../graphql/types/mutations/conversation";
import moment from "moment";
import { ISnoozeEntry } from "./ConversationToolbar";
import { SNOOZE_CONVERSATION } from "../../../graphql/mutations";
import Modal from "styled-react-modal";
import { SnoozePick } from "./modalsContents/SnoozePick";

const Svg = styled.svg``
const Path = styled.path`
transition: all 0.3s ease;`
const Btn = styled(Flex)`
  min-width:48px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor:pointer;
  position: relative;
  transition: all 0.3s ease;
  /* >${Svg} { */
  .pt {
fill: #556575;
  /* } */
  }
  &:hover {
    background:  #556575;
    .pt {
      fill: white;
    }
  }
`
const Wrapper = styled(Flex)`
  position: absolute;
  bottom: 40px;
  left: 0;
  width: 100%;
  justify-content: center;
  align-items: center;
  opacity:0.85;
  transition: all 0.3s ease;
  &:hover {
    opacity: 1;
  }
`
const IconsBar = styled(Flex)`
  padding: 6px 20px;
  border-radius: 36px;
  background: white;

`
const menuShow = keyframes`
  from {
    opacity: 0;
  }
`;
const menuHide = keyframes`
  to {
    opacity: 0;
  }
`;

export const Menu = styled(MenuInner)`
  ${menuSelector.name} {
    font-size: 0.925rem;
    user-select: none;
    box-shadow: 1px 1px 20px 1px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    padding: 6px;
    min-width: 10rem;
  }

  ${menuSelector.stateOpening} {
    animation: ${menuShow} 0.15s ease-out;
  }

  // NOTE: animation-fill-mode: forwards is required to
  // prevent flickering with React 18 createRoot()
  ${menuSelector.stateClosing} {
    animation: ${menuHide} 0.2s ease-out forwards;
  }

  ${menuItemSelector.name} {
    border-radius: 6px;
    padding: 0.375rem 0.625rem;
  }

  ${menuItemSelector.hover} {
    color: #fff;
    background-color: #59a2ff;
  }

  ${menuDividerSelector.name} {
    margin: 0.5rem 0.625rem;
  }

  ${menuItemSelector.submenu} {
    position: relative;
    &::after {
      position: absolute;
      width: 7px;
      right: 0.625rem;
    }
  }
`;

const transformToOption = (users: IHelpscoutUser[], session: IUser) => {
  return [...users].sort((a, b) => {
    if (a.id === session.helpscoutId) return -1
    return 1
  }).map(x => {
    return {
      label: x.id === session.helpscoutId ? 'Me' : `${x.firstName} ${x.lastName}`,
      value: x.id
    }
  })
}

const EmbedInputBarMinimized: React.FC<{
  onReply: () => void
  onNote: () => void
  onTags: () => void
  isHealthCoach: boolean
  conversationId: string
  isPatientConvo?: boolean
  athenaId?: string
  reassignConversation: (options?: MutationFunctionOptions<IProviderReassignConversationOutput, IProviderReassignConversationInput, DefaultContext, ApolloCache<any>> | undefined) => Promise<FetchResult<IProviderReassignConversationOutput>>
  changeStatusConversation: (options?: MutationFunctionOptions<IProviderChangeStatusConversationOutput, IProviderChangeStatusConversationInput, DefaultContext, ApolloCache<any>> | undefined) => Promise<FetchResult<IProviderChangeStatusConversationOutput>>
}> = ({ onReply, onNote, onTags,
  reassignConversation,
  conversationId,
  isPatientConvo,
  athenaId,
  isHealthCoach,
  changeStatusConversation }) => {
    console.log({ isHealthCoach, isPatientConvo })
    const [users, setUsers] = useState<Array<{
      label: string,
      value: number,
    }> | null>(null);
    const { session, loadingMe, errorMe } = useMe()
    const { data, loading, error } = useQuery<IGetHelpscoutUsersOutput, IIGetHelpscoutUsersInput>(GET_HELPSCOUT_USERS, {
      onCompleted: (e) => {

      }
    })
    const [filter, setFilter] = useState<string>('');
    const [snoozeMenuEntries, setSnoozeMenuEntry] = useState<Array<ISnoozeEntry>>([])
    const [snooze, { loading: loadingSnooze, error: errorSnooze, data: dataSnooze }] = useMutation<ISnoozeConversationOutput, ISnoozeConversationInput>(SNOOZE_CONVERSATION,{
      refetchQueries:[{query:GET_CONVERSATION_BY_ID, 
        variables: { conversationId: conversationId.toString() }
      }]
    })
    const [isPickDateTime, setIsPickDateTime] = useState(false)
    const toastIdChangeStatus = useRef<any>(null);
    const toastIdChangeAssignedTo = useRef<any>(null);
    const toastIdSetSnooze = useRef<any>(null);

    useEffect(() => {
      if (!!loading || loadingMe || !data || !session) return
      let opts = [{
        label: 'Anyone',
        value: -1
      }]

      opts = [...opts, ...transformToOption(data.getHelpscoutUsers, session.currentUserHealthCoach)]
      setUsers(opts)
      populateSnoozesEntries()
    }, [loading, loadingMe, session, data])

    useEffect(() => {
      populateSnoozesEntries()
    }, [])



    const getNextSnoozeDayAdd = () => {
      const day = moment().format('dddd')
      if (day === 'Sunday') {
        return {
          nextMonday: 1,
          nextWeekend: 6,
        }
      }
      if (day === 'Monday') {
        return {
          nextMonday: 7,
          nextWeekend: 5,
        }
      }
      if (day === 'Tuesday') {
        return {
          nextMonday: 6,
          nextWeekend: 4,
        }
      }
      if (day === 'Wednesday') {
        return {
          nextMonday: 5,
          nextWeekend: 3,
        }
      }
      if (day === 'Thursday') {
        return {
          nextMonday: 4,
          nextWeekend: 2,
        }
      }
      if (day === 'Friday') {
        return {
          nextMonday: 3,
          nextWeekend: 1,
        }
      }
      if (day === 'Saturday') {
        return {
          nextMonday: 2,
          nextWeekend: 7,
        }
      }
    }

    const getOptionsSnooze = () => {
      const day = moment().format('dddd')
  
      if (day === 'Monday' || day === 'Tuesday' || day === 'Sunday') {
        return [{
          title: 'Tomorrow',
          text: `Tomorrow, 8:00AM`,
          time: moment(moment().add(1, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `${moment(moment().add(2, 'day')).format('dddd')}`,
          text: `${moment(moment().add(2, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(2, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `${moment(moment().add(3, 'day')).format('dddd')}`,
          text: `${moment(moment().add(3, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(3, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `Next ${moment(moment().add(day === 'Sunday' ? 8 : 7, 'day')).format('dddd')}`,
          text: `Next ${moment(moment().add(day === 'Sunday' ? 8 : 7, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(day === 'Sunday' ? 8 : 7, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }]
      } else if (day === 'Wednesday') {
        return [{
          title: 'Tomorrow',
          text: `Tomorrow, 8:00AM`,
          time: moment(moment().add(1, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `${moment(moment().add(2, 'day')).format('dddd')}`,
          text: `${moment(moment().add(2, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(2, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: 'Monday',
          text: `Next ${moment(moment().add(5, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(5, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `Next ${moment(moment().add(7, 'day')).format('dddd')}`,
          text: `${moment(moment().add(7, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(7, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }]
      } else if (day === 'Thursday') {
        return [{
          title: 'Tomorrow',
          text: `Tomorrow, 8:00AM`,
          time: moment(moment().add(1, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `${moment(moment().add(4, 'day')).format('dddd')}`,
          text: `${moment(moment().add(4, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(4, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `${moment(moment().add(5, 'day')).format('dddd')}`,
          text: `${moment(moment().add(5, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(5, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `Next ${moment(moment().add(7, 'day')).format('dddd')}`,
          text: `${moment(moment().add(7, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(7, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }]
      } else if (day === 'Friday') {
        return [{
          title: `${moment(moment().add(3, 'day')).format('dddd')}`,
          text: `${moment(moment().add(3, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(3, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `${moment(moment().add(4, 'day')).format('dddd')}`,
          text: `${moment(moment().add(4, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(4, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `${moment(moment().add(5, 'day')).format('dddd')}`,
          text: `${moment(moment().add(5, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(5, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `${moment(moment().add(7, 'day')).format('dddd')}`,
          text: `${moment(moment().add(7, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(7, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }]
      } else if (day === 'Saturday') {
        return [{
          title: `${moment(moment().add(2, 'day')).format('dddd')}`,
          text: `${moment(moment().add(2, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(2, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `${moment(moment().add(3, 'day')).format('dddd')}`,
          text: `${moment(moment().add(3, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(3, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `${moment(moment().add(4, 'day')).format('dddd')}`,
          text: `${moment(moment().add(4, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(4, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }, {
          title: `Next ${moment(moment().add(9, 'day')).format('dddd')}`,
          text: `${moment(moment().add(9, 'day')).format('dddd')}, 8:00AM`,
          time: moment(moment().add(9, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        }]
      }
      return [{
        title: 'Tomorrow',
        text: `Tomorrow, 8:00AM`,
        time: moment(moment().add(1, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
      }, {
        title: `${moment(moment().add(2, 'day')).format('dddd')}`,
        text: `${moment(moment().add(2, 'day')).format('dddd')}, 8:00AM`,
        time: moment(moment().add(2, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
      }, {
        title: `${moment(moment().add(3, 'day')).format('dddd')}`,
        text: `${moment(moment().add(3, 'day')).format('dddd')}, 8:00AM`,
        time: moment(moment().add(3, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
      }, {
        title: `Next ${moment(moment().add(7, 'day')).format('dddd')}`,
        text: `Next ${moment(moment().add(7, 'day')).format('dddd')}, 8:00AM`,
        time: moment(moment().add(7, 'day').set('hour', 8)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
      }]
    }
    const populateSnoozesEntries = () => {
      const format = 'HH:mm:ss';
      const time = moment(moment().format(format), format);
      const beforeTime = moment('14:45:00', format);
      const nextDays = getNextSnoozeDayAdd()

      const res: Array<ISnoozeEntry> = []

      if (time.isBefore(beforeTime)) {
        res.push({
          title: 'Later today',
          text: `${moment().format('ddd')}, 3:00PM`,
          time: moment(moment().set('hour', 15)).set('minute', 0).set('second', 0).set('millisecond', 0).utc().toISOString()
        })
      }
      const arr = getOptionsSnooze()
      for (let index = 0; index < arr.length; index++) {
        const element = arr[index];
        res.push(element)
      }

      // res.push({
      //   title: 'Tomorrow',
      //   text: `${moment().add(1, 'day').format('ddd')}, 8:00AM`,
      //   time: moment(moment().add(1, 'day').set('hour', 8)).utc().set('minute', 0).set('second',0).set('millisecond',0).toISOString()
      // })

      // if (!!nextDays) {
      //   if (nextDays.nextMonday > nextDays.nextWeekend) {
      //     res.push({
      //       title: 'This weekend',
      //       text: `${moment().add(nextDays.nextWeekend, 'day').format('ddd')}, 8:00AM`,
      //       time: moment(moment().add(nextDays.nextWeekend, 'day').set('hour', 8)).utc().set('minute', 0).set('second',0).set('millisecond',0).format()
      //     })
      //     res.push({
      //       title: 'Next week',
      //       text: `${moment().add(nextDays.nextMonday, 'day').format('ddd')}, 8:00AM`,
      //       time: moment(moment().add(nextDays.nextMonday, 'day').set('hour', 8)).utc().set('minute', 0).set('second',0).set('millisecond',0).format()
      //     })
      //   } else {
      //     res.push({
      //       title: 'Next week',
      //       text: `${moment().add(nextDays.nextMonday, 'day').format('ddd')}, 8:00AM`,
      //       time: moment(moment().add(nextDays.nextMonday, 'day').set('hour', 8)).utc().set('minute', 0).set('second',0).set('millisecond',0).format()
      //     })
      //     res.push({
      //       title: 'Next weekend',
      //       text: `${moment().add(nextDays.nextWeekend, 'day').format('ddd')}, 8:00AM`,
      //       time: moment(moment().add(nextDays.nextWeekend, 'day').set('hour', 8)).utc().set('minute', 0).set('second',0).set('millisecond',0).format()
      //     })
      //   }
      // }
      setSnoozeMenuEntry(res)
    }

    return (
      <Wrapper>
        <IconsBar>
          <Btn onClick={onNote}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path className="pt" d="M14.1 9L15 9.9L5.9 19H5V18.1L14.1 9ZM17.7 3C17.5 3 17.2 3.1 17 3.3L15.2 5.1L18.9 8.9L20.7 7C21.1 6.6 21.1 6 20.7 5.6L18.4 3.3C18.2 3.1 17.9 3 17.7 3ZM14.1 6.2L3 17.2V21H6.8L17.8 9.9L14.1 6.2ZM7 2V5H10V7H7V10H5V7H2V5H5V2H7Z" />
            </svg>

          </Btn>
          <Menu
            onMenuChange={e => e.open && setFilter('')}
            transition
            overflow="auto"
            menuButton={
              <Btn data-for='tooltipConversationToolbar3' data-tip='Assign' >
                <Flex style={{ marginLeft: '-6px' }}>
                  <Svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <Path className="pt" d="M26.8282 23.8625C26.2387 22.4662 25.3832 21.1978 24.3095 20.1281C23.2389 19.0553 21.9708 18.2 20.5751 17.6094C20.5626 17.6031 20.5501 17.6 20.5376 17.5938C22.4845 16.1875 23.7501 13.8969 23.7501 11.3125C23.7501 7.03125 20.2813 3.5625 16.0001 3.5625C11.7188 3.5625 8.25008 7.03125 8.25008 11.3125C8.25008 13.8969 9.5157 16.1875 11.4626 17.5969C11.4501 17.6031 11.4376 17.6062 11.4251 17.6125C10.0251 18.2031 8.76883 19.05 7.6907 20.1313C6.61792 21.2018 5.76259 22.4699 5.17195 23.8656C4.59171 25.232 4.27877 26.697 4.25008 28.1812C4.24924 28.2146 4.25509 28.2478 4.26728 28.2788C4.27947 28.3099 4.29776 28.3382 4.32105 28.3621C4.34435 28.386 4.3722 28.4049 4.40294 28.4179C4.43369 28.4308 4.46672 28.4375 4.50008 28.4375H6.37508C6.51258 28.4375 6.62195 28.3281 6.62508 28.1938C6.68758 25.7813 7.65633 23.5219 9.36883 21.8094C11.1407 20.0375 13.4938 19.0625 16.0001 19.0625C18.5063 19.0625 20.8595 20.0375 22.6313 21.8094C24.3438 23.5219 25.3126 25.7813 25.3751 28.1938C25.3782 28.3313 25.4876 28.4375 25.6251 28.4375H27.5001C27.5334 28.4375 27.5665 28.4308 27.5972 28.4179C27.628 28.4049 27.6558 28.386 27.6791 28.3621C27.7024 28.3382 27.7207 28.3099 27.7329 28.2788C27.7451 28.2478 27.7509 28.2146 27.7501 28.1812C27.7188 26.6875 27.4095 25.2344 26.8282 23.8625V23.8625ZM16.0001 16.6875C14.5657 16.6875 13.2157 16.1281 12.2001 15.1125C11.1845 14.0969 10.6251 12.7469 10.6251 11.3125C10.6251 9.87812 11.1845 8.52812 12.2001 7.5125C13.2157 6.49687 14.5657 5.9375 16.0001 5.9375C17.4345 5.9375 18.7845 6.49687 19.8001 7.5125C20.8157 8.52812 21.3751 9.87812 21.3751 11.3125C21.3751 12.7469 20.8157 14.0969 19.8001 15.1125C18.7845 16.1281 17.4345 16.6875 16.0001 16.6875Z" />
                  </Svg>
                  <Svg width="16" height="16" style={{ position: 'absolute', left: 30, top: 8 }} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <Path className="pt" d="M21.724 12.3907L16 18.1147L10.276 12.3907L8.39062 14.276L16 21.8854L23.6093 14.276L21.724 12.3907Z" />
                  </Svg>
                </Flex>
              </Btn>
            }>
            {!users ? (<MenuItem>Loading</MenuItem>) : (
              <>
                <FocusableItem>
                  {({ ref }) => (
                    <InputNoForm style={{ borderRadius: 0, height: '28px', fontSize: '12px' }} inputRef={ref} type="text" placeholder="Type to filter"
                      value={filter} onChange={(e: any) => setFilter(e.target.value)} />
                  )}
                </FocusableItem>
                {users.filter(x => x.label.toLowerCase().indexOf(filter.toLowerCase()) > -1).map(x => {
                  return <MenuItem key={x.value}
                    onClick={async () => {
                      if (toastIdChangeAssignedTo && toastIdChangeAssignedTo.current) {
                        toast.dismiss(toastIdChangeAssignedTo.current)
                      }
                      toastIdChangeAssignedTo.current = toast(`Reassigning to ${x.label}`, { autoClose: false, isLoading: true, closeButton: false });
                      await reassignConversation({
                        variables: {
                          conversationId: conversationId,
                          assignedTo: x.value
                        }
                      })
                      toast.update(toastIdChangeAssignedTo.current, {
                        render: 'Conversation reassigned',
                        type: toast.TYPE.SUCCESS,
                        isLoading: false,
                        autoClose: 5000,
                        closeButton: null // The closeButton defined on ToastContainer will be used
                      });
                    }}>{x.label}</MenuItem>
                })}
              </>
            )}
          </Menu>
          <Menu transition menuButton={
            <Btn data-for='tooltipConversationToolbar4' data-tip='Status'>
              <Flex style={{ marginLeft: '-6px' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path className="pt" d="M5.5 20.5C5.23478 20.5 4.98043 20.3947 4.79289 20.2071C4.60536 20.0196 4.5 19.7652 4.5 19.5V4.50002C4.5 4.23481 4.60536 3.98045 4.79289 3.79292C4.98043 3.60538 5.23478 3.50002 5.5 3.50002H11.88C12.0664 3.49873 12.2494 3.54954 12.4084 3.64672C12.5674 3.7439 12.6961 3.88359 12.78 4.05002L13.5 5.50002H18.5C18.7652 5.50002 19.0196 5.60538 19.2071 5.79292C19.3946 5.98045 19.5 6.23481 19.5 6.50002V14.5C19.5 14.7652 19.3946 15.0196 19.2071 15.2071C19.0196 15.3947 18.7652 15.5 18.5 15.5H13.11C12.9253 15.4995 12.7444 15.4478 12.5873 15.3507C12.4302 15.2536 12.3031 15.1149 12.22 14.95L11.5 13.5H6.5V19.5C6.5 19.7652 6.39464 20.0196 6.20711 20.2071C6.01957 20.3947 5.76522 20.5 5.5 20.5V20.5ZM6.5 5.50002V11.5H12.5L13.5 13.5H17.5V7.50002H12.5L11.5 5.50002H6.5Z" />
                </svg>

                <svg width="16" height="16" style={{ position: 'absolute', left: 30, top: 8 }} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path className="pt" d="M21.724 12.3907L16 18.1147L10.276 12.3907L8.39062 14.276L16 21.8854L23.6093 14.276L21.724 12.3907Z" />
                </svg>
              </Flex>
            </Btn>
          }>
            <MenuItem onClick={async () => {
              if (toastIdChangeStatus && toastIdChangeStatus.current) {
                toast.dismiss(toastIdChangeStatus.current)
              }
              toastIdChangeStatus.current = toast(`Changing conversation status to OPEN`, { autoClose: false, isLoading: true, closeButton: false });
              await changeStatusConversation({
                variables: {
                  conversationId: conversationId,
                  status: 'open',
                  userId: session!.currentUserHealthCoach.helpscoutId
                }
              })
              toast.update(toastIdChangeStatus.current, {
                render: 'Conversation status is now OPEN',
                type: toast.TYPE.SUCCESS,
                isLoading: false,
                autoClose: 5000,
                closeButton: null // The closeButton defined on ToastContainer will be used
              });
            }}>Opened</MenuItem>
            <MenuItem onClick={async () => {
              if (toastIdChangeStatus && toastIdChangeStatus.current) {
                toast.dismiss(toastIdChangeStatus.current)
              }
              toastIdChangeStatus.current = toast(`Changing conversation status to PENDING`, { autoClose: false, isLoading: true, closeButton: false });
              await changeStatusConversation({
                variables: {
                  conversationId: conversationId,
                  status: 'pending',
                  userId: session!.currentUserHealthCoach.helpscoutId
                }
              })
              toast.update(toastIdChangeStatus.current, {
                render: 'Conversation status is now PENDING',
                type: toast.TYPE.SUCCESS,
                isLoading: false,
                autoClose: 5000,
                closeButton: null // The closeButton defined on ToastContainer will be used
              });
            }}>Pending</MenuItem>
            <MenuItem onClick={async () => {
              if (toastIdChangeStatus && toastIdChangeStatus.current) {
                toast.dismiss(toastIdChangeStatus.current)
              }
              toastIdChangeStatus.current = toast(`Changing conversation status to CLOSED`, { autoClose: false, isLoading: true, closeButton: false });
              await changeStatusConversation({
                variables: {
                  conversationId: conversationId,
                  status: 'closed',
                  userId: session!.currentUserHealthCoach.helpscoutId
                }
              })
              toast.update(toastIdChangeStatus.current, {
                render: 'Conversation status is now CLOSED',
                type: toast.TYPE.SUCCESS,
                isLoading: false,
                autoClose: 5000,
                closeButton: null // The closeButton defined on ToastContainer will be used
              });
            }}>Closed</MenuItem>
          </Menu>

          <Btn data-for='tooltipConversationToolbar5' data-tip='Tags' onClick={onTags}>
            <svg width="24" height="24" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M26.8334 15.1601L26.8334 15.16C27.5269 14.4666 27.9166 13.526 27.9166 12.5453V5.49023C27.9166 4.85206 27.6631 4.24002 27.2119 3.78876C26.7606 3.33752 26.1486 3.08401 25.5105 3.08398C25.5105 3.08398 25.5104 3.08398 25.5104 3.08398L18.4515 3.08528L18.4513 3.08528C17.9652 3.08516 17.4839 3.18086 17.0349 3.36693C16.5858 3.55298 16.1779 3.82573 15.8344 4.16958L26.8334 15.1601ZM26.8334 15.1601L15.8547 26.1427M26.8334 15.1601L15.8547 26.1427M15.8547 26.1427C15.8545 26.1428 15.8544 26.1429 15.8543 26.1431M15.8547 26.1427L15.8543 26.1431M15.8543 26.1431C15.16 26.8355 14.2196 27.2244 13.2391 27.2246C12.2585 27.2249 11.3178 26.8363 10.6233 26.144L15.8543 26.1431ZM4.85531 15.1615L15.8343 4.16962L10.623 26.1438L4.85986 20.391C4.85985 20.391 4.85984 20.391 4.85983 20.3909C4.16582 19.6981 3.77545 18.7579 3.7746 17.7772C3.77375 16.7966 4.16244 15.8557 4.85519 15.1617C4.85523 15.1616 4.85527 15.1616 4.85531 15.1615ZM16.4975 4.83056L16.4973 4.83078L5.50261 15.8397L5.50259 15.8396L5.49888 15.8434C4.99052 16.3634 4.70785 17.0629 4.71228 17.7901C4.71671 18.5172 5.00786 19.2132 5.52249 19.7269C5.52251 19.7269 5.52252 19.7269 5.52254 19.7269L11.2846 25.48L11.285 25.4804C11.8036 25.9969 12.5057 26.2869 13.2376 26.2869C13.9695 26.2869 14.6716 25.9969 15.1902 25.4804L15.191 25.4796L26.1699 14.4968C26.6877 13.9794 26.9788 13.2775 26.9791 12.5456V12.5453V5.49023C26.9791 5.1007 26.8244 4.72712 26.549 4.45167C26.2735 4.17623 25.8999 4.02148 25.5104 4.02148H18.4501C17.718 4.02148 17.0148 4.31324 16.4975 4.83056ZM21.9583 7.6074C22.1471 7.6074 22.334 7.64458 22.5084 7.71682C22.6828 7.78906 22.8413 7.89495 22.9748 8.02844C23.1083 8.16192 23.2141 8.32039 23.2864 8.49479C23.3586 8.6692 23.3958 8.85613 23.3958 9.0449C23.3958 9.23368 23.3586 9.4206 23.2864 9.59501C23.2141 9.76941 23.1083 9.92788 22.9748 10.0614C22.8413 10.1949 22.6828 10.3007 22.5084 10.373C22.334 10.4452 22.1471 10.4824 21.9583 10.4824C21.5771 10.4824 21.2114 10.331 20.9418 10.0614C20.6723 9.79178 20.5208 9.42615 20.5208 9.0449C20.5208 8.66365 20.6723 8.29802 20.9418 8.02843C21.2114 7.75885 21.5771 7.6074 21.9583 7.6074Z" stroke="#4E658A" />
            </svg>
          </Btn>
          {isPatientConvo && (
            <Menu menuStyle={{
              minWidth: '300px'
            }}
              transition menuButton={
                <Btn
                  disabled={loadingSnooze}
                  data-for='tooltipConversationToolbar6'
                  data-tip='Snooze'>
                  <Flex style={{ marginLeft: '-6px' }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.5 1.5C16.3011 1.5 16.1103 1.57902 15.9697 1.71967C15.829 1.86032 15.75 2.05109 15.75 2.25C15.75 2.44891 15.829 2.63968 15.9697 2.78033C16.1103 2.92098 16.3011 3 16.5 3H20.31L15.885 9.3195C15.8062 9.43194 15.7598 9.56386 15.7508 9.70087C15.7418 9.83789 15.7706 9.97474 15.834 10.0965C15.8974 10.2183 15.9931 10.3203 16.1105 10.3915C16.228 10.4626 16.3627 10.5002 16.5 10.5H21.75C21.9489 10.5 22.1397 10.421 22.2803 10.2803C22.421 10.1397 22.5 9.94891 22.5 9.75C22.5 9.55109 22.421 9.36032 22.2803 9.21967C22.1397 9.07902 21.9489 9 21.75 9H17.94L22.365 2.6805C22.4438 2.56806 22.4903 2.43615 22.4993 2.29913C22.5082 2.16211 22.4795 2.02526 22.416 1.90348C22.3526 1.7817 22.2569 1.67968 22.1395 1.60853C22.022 1.53738 21.8873 1.49984 21.75 1.5H16.5ZM9.75001 7.5C9.5511 7.5 9.36033 7.57902 9.21968 7.71967C9.07903 7.86032 9.00001 8.05109 9.00001 8.25C9.00001 8.44891 9.07903 8.63968 9.21968 8.78033C9.36033 8.92098 9.5511 9 9.75001 9H11.898L9.17401 12.27C9.0828 12.3795 9.02468 12.5127 9.00645 12.6541C8.98822 12.7954 9.01064 12.939 9.07108 13.0681C9.13151 13.1971 9.22747 13.3063 9.34771 13.3828C9.46795 13.4593 9.6075 13.4999 9.75001 13.5H13.5C13.6989 13.5 13.8897 13.421 14.0303 13.2803C14.171 13.1397 14.25 12.9489 14.25 12.75C14.25 12.5511 14.171 12.3603 14.0303 12.2197C13.8897 12.079 13.6989 12 13.5 12H11.352L14.076 8.73C14.1672 8.6205 14.2253 8.48728 14.2436 8.34594C14.2618 8.2046 14.2394 8.06099 14.1789 7.93193C14.1185 7.80287 14.0225 7.6937 13.9023 7.6172C13.7821 7.54071 13.6425 7.50005 13.5 7.5H9.75001ZM12 4.5C10.6076 4.5 9.27226 5.05312 8.2877 6.03769C7.30313 7.02226 6.75001 8.35761 6.75001 9.75V13.5C6.74995 13.5956 6.73162 13.6903 6.69601 13.779L5.61001 16.5H18.3945L17.3055 13.779C17.2693 13.6904 17.2505 13.5957 17.25 13.5V12.75C17.25 12.5511 17.329 12.3603 17.4697 12.2197C17.6103 12.079 17.8011 12 18 12C18.1989 12 18.3897 12.079 18.5303 12.2197C18.671 12.3603 18.75 12.5511 18.75 12.75V13.356L20.196 16.971C20.2416 17.0848 20.2586 17.208 20.2456 17.3299C20.2325 17.4518 20.1898 17.5687 20.1211 17.6702C20.0524 17.7717 19.9599 17.8549 19.8516 17.9124C19.7433 17.9699 19.6226 18 19.5 18H15C15 18.7956 14.6839 19.5587 14.1213 20.1213C13.5587 20.6839 12.7957 21 12 21C11.2044 21 10.4413 20.6839 9.87869 20.1213C9.31608 19.5587 9.00001 18.7956 9.00001 18H4.50001C4.37742 18 4.2567 17.9699 4.14843 17.9124C4.04016 17.8549 3.94763 17.7717 3.87895 17.6702C3.81026 17.5687 3.76752 17.4518 3.75445 17.3299C3.74139 17.208 3.7584 17.0848 3.80401 16.971L5.25001 13.356V9.75C5.24962 8.64443 5.52079 7.55568 6.0397 6.57945C6.55861 5.60322 7.30937 4.76939 8.22599 4.15125C9.14261 3.53311 10.197 3.14958 11.2966 3.03437C12.3961 2.91915 13.5072 3.07579 14.532 3.4905C14.6233 3.52753 14.7064 3.58219 14.7766 3.65134C14.8468 3.72049 14.9027 3.80279 14.941 3.89354C14.9794 3.98428 14.9995 4.0817 15.0003 4.18022C15.001 4.27875 14.9823 4.37645 14.9453 4.46775C14.9082 4.55905 14.8536 4.64217 14.7844 4.71235C14.7153 4.78252 14.633 4.8384 14.5422 4.87677C14.4515 4.91514 14.3541 4.93527 14.2555 4.93599C14.157 4.93672 14.0593 4.91803 13.968 4.881C13.3427 4.62838 12.6744 4.49901 12 4.5ZM10.5 18C10.5 18.3978 10.658 18.7794 10.9393 19.0607C11.2207 19.342 11.6022 19.5 12 19.5C12.3978 19.5 12.7794 19.342 13.0607 19.0607C13.342 18.7794 13.5 18.3978 13.5 18H10.5Z" fill="#4E658A" />
                    </svg>

                    <svg width="16" height="16" style={{ position: 'absolute', left: 30, top: 14 }} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.724 12.3907L16 18.1147L10.276 12.3907L8.39062 14.276L16 21.8854L23.6093 14.276L21.724 12.3907Z" fill="#556575" />
                    </svg>
                  </Flex>
                </Btn>
              }>
              <Text style={{ marginLeft: '10px', marginTop: '4px', marginBottom: '8px', fontWeight: 600, opacity: 0.75 }}>Snooze until...</Text>
              {snoozeMenuEntries.map(x => {
                return (
                  <MenuItem key={x.time} style={{ marginTop: '4px' }} onClick={async () => {
                    if (!athenaId) return
                    if (toastIdSetSnooze && toastIdSetSnooze.current) {
                      toast.dismiss(toastIdSetSnooze.current)
                    }
                    toastIdSetSnooze.current = toast(`Setting snooze`, { autoClose: false, isLoading: true, closeButton: false });
                    await snooze({
                      variables: {
                        athenaId: athenaId,
                        conversationId: conversationId,
                        snoozeUntil: x.time
                      }
                    })
                    toast.update(toastIdSetSnooze.current, {
                      render: 'Snooze Set',
                      type: toast.TYPE.SUCCESS,
                      isLoading: false,
                      autoClose: 5000,
                      closeButton: null // The closeButton defined on ToastContainer will be used
                    });
                  }}>
                    <Flex flex={1} style={{ width: '100%' }}>
                      <Text fontWeight={400} flex={1}>{x.title}</Text>
                      <Text fontWeight={400} style={{ opacity: 0.83 }} >{x.text}</Text>
                    </Flex>
                  </MenuItem>
                )
              })}
              <MenuDivider />
              <MenuItem style={{ marginTop: '4px' }} onClick={async () => {
                setIsPickDateTime(true)
              }}>
                <Flex alignItems={'center'} flex={1} style={{ width: '100%' }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 19H5V8H19M16 1V3H8V1H6V3H5C3.89 3 3 3.89 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H18V1M17 12H12V17H17V12Z" fill="#556575" />
                  </svg>
                  <Text ml={3} fontWeight={400}>{'Pick Date & Time'}</Text>
                </Flex>
              </MenuItem>
            </Menu>
          )}
          <Box backgroundColor={'#7992B3'} style={{ height: '30px%', width: 1 }} marginX={2}></Box>
          {/* </Btn> */}
          <Btn backgroundColor={'#344F7A'} onClick={onReply}>
            <svg width="24" height="24" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.3125 9.06299C17.5208 9.06299 18.6772 9.28955 19.7817 9.74268C20.8862 10.1958 21.868 10.8519 22.7271 11.7109C23.5861 12.57 24.2422 13.5518 24.6953 14.6562C25.1484 15.7607 25.375 16.9172 25.375 18.1255C25.375 19.381 25.139 20.5563 24.667 21.6514C24.195 22.7464 23.5483 23.7093 22.7271 24.54C21.9058 25.3708 20.9476 26.0174 19.8525 26.48C18.7575 26.9425 17.5775 27.1785 16.3125 27.188V25.3755C17.3132 25.3755 18.2524 25.1867 19.1304 24.8091C20.0083 24.4315 20.7729 23.9123 21.4243 23.2515C22.0757 22.5907 22.5949 21.8213 22.9819 20.9434C23.369 20.0654 23.5625 19.1261 23.5625 18.1255C23.5625 17.1248 23.3737 16.1855 22.9961 15.3076C22.6185 14.4297 22.0993 13.665 21.4385 13.0137C20.7777 12.3623 20.0083 11.8431 19.1304 11.4561C18.2524 11.069 17.3132 10.8755 16.3125 10.8755H6.72607L12.4185 16.582L11.144 17.8564L3.25684 9.96924L11.144 2.08203L12.4185 3.35645L6.72607 9.06299H16.3125Z" fill="white" />
            </svg>


          </Btn>


        </IconsBar>

        <Modal
          isOpen={!!isPickDateTime}>
          <Flex flexDirection={'column'}

            style={{
              margin: '0 auto',
              alignSelf: 'center',
              borderRadius: '20px',
              position: 'relative',
              backgroundColor: 'white',
              padding: '24px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              // overflow: 'hidden'
            }}>
            <Flex>
              <SnoozePick isSaving={loadingSnooze} onCancel={() => setIsPickDateTime(false)} onSave={async (date) => {
                if (!athenaId) return

                if (toastIdSetSnooze && toastIdSetSnooze.current) {
                  toast.dismiss(toastIdSetSnooze.current)
                }
                toastIdSetSnooze.current = toast(`Setting snooze`, { autoClose: false, isLoading: true, closeButton: false });
                await snooze({
                  variables: {
                    athenaId: athenaId,
                    conversationId: conversationId,
                    snoozeUntil: moment(date, 'MM-DD-YYYYThh:mmA').utc().format()
                  }
                })
                toast.update(toastIdSetSnooze.current, {
                  render: 'Snooze Set',
                  type: toast.TYPE.SUCCESS,
                  isLoading: false,
                  autoClose: 5000,
                  closeButton: null // The closeButton defined on ToastContainer will be used
                });
                console.log({
                  date: date,
                  local: moment(date, 'MM-DD-YYYYThh:mmA').format('MM/DD/YYYY HH:mm'),
                  utc: moment(date, 'MM-DD-YYYYThh:mmA').utc().format('MM/DD/YYYY HH:mm')
                })
                setIsPickDateTime(false)
              }} />
            </Flex>
          </Flex>
        </Modal>
      </Wrapper>
    )
  }

export default EmbedInputBarMinimized